import { EditableText } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";

export interface EditableTextWithIconCellValue {
  value: string;
  placeholder?: string;
  emptyLabel?: string;
  disabled?: boolean;
}

interface EditableTextWithIconCellProps {
  value: EditableTextWithIconCellValue;
  rowData?: any;
  header?: string;
  onCellValueChange?: (rowData: any, fieldKey: string, newValue: any) => void;
}

const EditableTextWithIconCell: React.FC<EditableTextWithIconCellProps> = ({
  value,
  rowData,
  header,
  onCellValueChange,
}) => {
  /**
   * Key remount the oasis EditableText whenever the row changes, otherwise its
   * uncontrolled internal state sticks across pagination/sort/filter swaps and
   * we render the previous row's text.
   */
  const remountKey = `${rowData?.id ?? "row"}-${header ?? ""}`;
  return (
    <div onClick={(e) => e.stopPropagation()}>
      <EditableText
        key={remountKey}
        value={value.value || ""}
        defaultValue={value.value || ""}
        placeholder={value.placeholder}
        emptyText={value.emptyLabel || "—"}
        disabled={value.disabled}
        size="small"
        saveOnBlur
        saveOnEnter
        cancelOnEscape
        onSave={(next) =>
          onCellValueChange?.(rowData, header || "", next.trim())
        }
      />
    </div>
  );
};

export default EditableTextWithIconCell;
